import React from 'react';
import type { Client } from '../../types';
import { Button } from '../shared';
import styles from './ClientCard.module.css';

interface ClientCardProps {
  client: Client;
  onViewPrograms: (client: Client) => void;
  onCheckin: (client: Client) => void;
  onDelete: (clientId: string) => void;
  onGenerateProgram?: (client: Client) => void;
}

const goalLabels: Record<Client['goal'], string> = {
  muscle_gain: 'Muscle Gain',
  fat_loss: 'Fat Loss',
  strength: 'Strength',
  endurance: 'Endurance',
  rehab: 'Rehabilitation',
};

const levelLabels: Record<Client['level'], string> = {
  beginner: 'Beginner',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
};

export const ClientCard: React.FC<ClientCardProps> = ({
  client,
  onViewPrograms,
  onCheckin,
  onDelete,
  onGenerateProgram,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.name}>{client.name}</h3>
        <span className={`${styles.level} ${styles[client.level]}`}>
          {levelLabels[client.level]}
        </span>
      </div>

      <div className={styles.details}>
        <div className={styles.detail}>
          <span className={styles.label}>Age</span>
          <span className={styles.value}>{client.age}</span>
        </div>
        <div className={styles.detail}>
          <span className={styles.label}>Goal</span>
          <span className={styles.value}>{goalLabels[client.goal]}</span>
        </div>
        <div className={styles.detail}>
          <span className={styles.label}>Days/Week</span>
          <span className={styles.value}>{client.daysPerWeek}</span>
        </div>
        <div className={styles.detail}>
          <span className={styles.label}>Equipment</span>
          <span className={styles.value}>{client.equipment.replace('_', ' ')}</span>
        </div>
      </div>

      {client.injuries && (
        <div className={styles.injuries}>
          <span className={styles.injuryLabel}>Injuries:</span>
          <span className={styles.injuryValue}>{client.injuries}</span>
        </div>
      )}

      <div className={styles.actionRows}>
        <div className={styles.actionRow}>
          <Button
            variant="primary"
            fullWidth
            onClick={() => onGenerateProgram ? onGenerateProgram(client) : onViewPrograms(client)}
          >
            Generate Program
          </Button>
        </div>
        <div className={styles.actionRow}>
          <Button
            variant="secondary"
            className={styles.halfButton}
            onClick={() => onCheckin(client)}
          >
            Check-in
          </Button>
          <Button
            variant="secondary"
            className={styles.halfButton}
            onClick={() => onViewPrograms(client)}
          >
            View Programs
          </Button>
        </div>
        <div className={styles.actionRow}>
          <button
            className={styles.deleteButton}
            onClick={() => onDelete(client.id)}
          >
            Delete Client
          </button>
        </div>
      </div>
    </div>
  );
};
